<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .direction {
    @include colors.color(black_90);
    @include colors.background-color(interfaceSwGrey_10);
    @include mixins.body2();
    display: flex;
    align-items: center;
    gap: utils.in_rem(12px);
    padding: utils.in_rem(2px) utils.in_rem(8px);
    border-radius: 200px;
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";

  let { kind, skeleton = false } = $props();

  const kindMap = {
    inbound: {
      label: "Inbound",
      icon: "far fa-phone-arrow-down-left",
    },
    outbound: {
      label: "Outbound",
      icon: "far fa-phone-arrow-up-right",
    },
  };

  const kindInfo = $derived(kindMap[kind]);
  const label = $derived(kindInfo.label);
  const icon = $derived(kindInfo.icon);
</script>

{#if skeleton}
  <span class:skeleton>Loading...</span>
{:else}
  <div class="direction">
    <Icon size="xs" class={icon} {skeleton} />
    <span class:skeleton>{label}</span>
  </div>
{/if}
